/**
 * Environment Configuration
 * Contains all environment-specific settings for the application
 */

import { getEnvironmentTier } from '../utils/environment';

export interface EnvironmentConfig {
  paddle: {
    clientToken: string;
    vendorId: string; // Legacy, kept for reference
  };
  stripe?: {
    publicKey: string;
  };
}

const CONFIGS: Record<'sandbox' | 'production', EnvironmentConfig> = {
  sandbox: {
    paddle: {
      // Sandbox client-side token for Paddle.js SDK
      clientToken: 'test_631f1a58e618e364df1c38e5a8d',
      vendorId: '39188' // Legacy vendor ID
    },
    stripe: {
      publicKey: 'pk_test_51SKDbyIczEZlgnndisYk3h9NWSgJC5ddzsCFGfgi7jE8vv3eQzuSitNlIOrKnkOlw3cDqVx9W540DnlPlN9u4csf00G0Pyhxic'
    }
  },
  production: {
    paddle: {
      // Production client-side token for Paddle.js SDK
      clientToken: 'live_5916b21c1fff3e36098c9a75c90',
      vendorId: '258684' // Legacy vendor ID
    },
    stripe: {
      publicKey: '' // TODO: Add Stripe production public key if needed
    }
  }
};

/**
 * Get the configuration for the current environment
 */
export function getEnvConfig(): EnvironmentConfig {
  const tier = getEnvironmentTier();
  return CONFIGS[tier];
}

/**
 * Get Paddle client token for current environment
 */
export function getPaddleClientToken(): string {
  return getEnvConfig().paddle.clientToken;
}

/**
 * Get Stripe public key for current environment
 */
export function getStripePublicKey(): string | undefined {
  return getEnvConfig().stripe?.publicKey;
}